import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import ScrollToTop from "@/components/ScrollToTop";
import Index from "./pages/home/Index";
import Admin from "@/pages/admin/Index";
import NotFound from "./pages/not-found/Index";
import { LangProvider } from "@/i18n/LangContext";
import Fleckenschutz from "@/pages/flexschutz/Index";
import UeberUns from "@/pages/ueber-uns/Index";
import Impressum from "@/pages/impressum/Index";
import Montage from "@/pages/montage/Index";
import Entsorgung from "@/pages/entsorgung/Index";
import Logistik from "@/pages/logistik/Index";
import Showroom from "@/pages/showroom/Index";
import Elektro from "@/pages/elektro/Index";
import Zuegel from "@/pages/zuegel/Index";
import Offerte from "@/pages/offerte/Index";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Sonner />
      <LangProvider>
        <HashRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="/flexschutz" element={<Fleckenschutz />} />
            <Route path="/ueber-uns" element={<UeberUns />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/montage" element={<Montage />} />
            <Route path="/entsorgung" element={<Entsorgung />} />
            <Route path="/logistik" element={<Logistik />} />
            <Route path="/showroom" element={<Showroom />} />
            <Route path="/elektro" element={<Elektro />} />
            <Route path="/zuegel" element={<Zuegel />} />
            <Route path="/offerte" element={<Offerte />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </HashRouter>
      </LangProvider>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
